"use client";

import React from "react";

import { createSVGIcon } from "../util";

import { IPaymentMethodsIconProps } from "./IPaymentMethodsIconProps";

// https://docs.adyen.com/online-payments/api-only/downloading-logos
/**
 * @trackcomponent
 * @donotoptimize everything but the border disappears (@quinlan.sokol)
 */
const SquareLogo = createSVGIcon(
  <>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="50.18"
        y1="35.88"
        x2="90.32"
        y2="-4.26"
        gradientTransform="matrix(1, 0, 0, -1, 0, 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#289847" />
        <stop offset="0.49" stopColor="#1787b9" />
        <stop offset="1" stopColor="#1d3564" />
      </linearGradient>
    </defs>
    <title>new-square</title>
    <path
      d="M53-7.81H87.5a2.75,2.75,0,0,1,2.75,2.75v34.5a2.75,2.75,0,0,1-2.75,2.75H53a2.75,2.75,0,0,1-2.75-2.75V-5.06A2.75,2.75,0,0,1,53-7.81Z"
      transform="translate(-50.25 7.81)"
      style={{ fill: "url(#linear-gradient)" }}
    />
    <g id="g14">
      <path
        id="path8"
        d="M87.13,7.84a3.88,3.88,0,0,0-.29-1.44,3.63,3.63,0,0,0-.75-1.16,2.51,2.51,0,0,0-1.25-.76A5.08,5.08,0,0,0,83,4.28H72.46v7.09H82.91a8,8,0,0,0,1.82-.2A3.41,3.41,0,0,0,86,10.42a3.88,3.88,0,0,0,.76-1.16,2.73,2.73,0,0,0,.38-1.41"
        transform="translate(-50.25 7.81)"
        style={{ fill: "#fff" }}
      />
      <path
        id="path10"
        d="M87.13,16.56a3.88,3.88,0,0,0-.29-1.44A3.63,3.63,0,0,0,86.08,14a2.51,2.51,0,0,0-1.25-.76A5.08,5.08,0,0,0,83,13H72.46v7.09H82.91a8,8,0,0,0,1.82-.2A3.41,3.41,0,0,0,86,19.13,3.88,3.88,0,0,0,86.74,18a2.67,2.67,0,0,0,.38-1.41"
        transform="translate(-50.25 7.81)"
        style={{ fill: "#fff" }}
      />
      <path
        id="path12"
        d="M71,11.39c-0.38-4.6-3.64-7.64-8.82-7.64-5.47,0-8.82,3.4-8.82,8.44,0,5.27,3.55,8.44,8.82,8.44s8.44-3,8.82-7.64H62.1V11.3H71v0.09h0Z"
        transform="translate(-50.25 7.81)"
        style={{ fill: "#fff" }}
      />
    </g>
    <rect
      x="0.25"
      y="0.25"
      width="39.5"
      height="39.5"
      rx="2.75"
      fill="url(#pattern0)"
      stroke="#AAAAAA"
      strokeWidth="0.5"
    />
  </>,
  "CartesBancairesSquare",
  {
    viewBox: "0 0 40 40",
    titleAccess: "Square Cartes Bancaires Icon",
    fill: "none",
  }
);

/**
 * @trackcomponent
 * @donotoptimize everything but the border disappears (@quinlan.sokol)
 */
const Logo = createSVGIcon(
  <>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="3.59"
        y1="31.41"
        x2="36.41"
        y2="-1.41"
        gradientTransform="matrix(1, 0, 0, -1, 0, 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#289847" />
        <stop offset="0.49" stopColor="#1787b9" />
        <stop offset="1" stopColor="#1d3564" />
      </linearGradient>
      <mask
        id="mask"
        x="6.94"
        y="7.57"
        width="14.02"
        height="11.43"
        maskUnits="userSpaceOnUse"
      />
      <linearGradient
        id="linear-gradient-2"
        x1="0"
        y1="28"
        x2="0"
        y2="28"
        xlinkHref="#linear-gradient"
      />
    </defs>
    <path
      d="M2.75,0h34.5A2.75,2.75,0,0,1,40,2.75v20.5A2.75,2.75,0,0,1,37.25,26H2.75A2.75,2.75,0,0,1,0,23.25V2.75A2.75,2.75,0,0,1,2.75,0Z"
      style={{ fill: "url(#linear-gradient)" }}
    />
    <g style={{ mask: "url(#mask)" }}>
      <path d="M0,0" style={{ fill: "url(#linear-gradient-2)" }} />
    </g>
    <path d="M0,0" style={{ fill: "url(#linear-gradient-2)" }} />
    <g id="g14">
      <path
        id="path8"
        d="M36.88,8.65a3.88,3.88,0,0,0-.29-1.44,3.63,3.63,0,0,0-.75-1.16,2.51,2.51,0,0,0-1.25-.76,5.08,5.08,0,0,0-1.82-.2H22.21v7.09H32.66a8,8,0,0,0,1.82-.2,3.41,3.41,0,0,0,1.25-.76,3.88,3.88,0,0,0,.76-1.16,2.73,2.73,0,0,0,.38-1.41"
        style={{ fill: "#fff" }}
      />
      <path
        id="path10"
        d="M36.88,17.37a3.88,3.88,0,0,0-.29-1.44,3.63,3.63,0,0,0-.75-1.16A2.51,2.51,0,0,0,34.58,14a5.08,5.08,0,0,0-1.82-.2H22.21V20.9H32.66a8,8,0,0,0,1.82-.2,3.41,3.41,0,0,0,1.25-.76,3.88,3.88,0,0,0,.76-1.16,2.67,2.67,0,0,0,.38-1.41"
        style={{ fill: "#fff" }}
      />
      <path
        id="path12"
        d="M20.76,12.2c-0.38-4.6-3.64-7.64-8.82-7.64C6.47,4.56,3.13,8,3.13,13c0,5.27,3.55,8.44,8.82,8.44s8.44-3,8.82-7.64H11.85V12.11h8.91V12.2h0Z"
        style={{ fill: "#fff" }}
      />
    </g>
    <rect
      x="0.25"
      y="0.25"
      width="39.5"
      height="25.5"
      rx="2.75"
      fill="url(#pattern0)"
      stroke="#AAAAAA"
      strokeWidth="0.5"
    />
  </>,
  "CartesBancaires",
  {
    viewBox: "0 0 40 26",
    titleAccess: "Cartes Bancaires Icon",
    fill: "none",
  }
);

export const CB = React.memo(
  ({
    square,
    monochrome,
    ref,
    ...iconProps
  }: IPaymentMethodsIconProps & React.RefAttributes<SVGElement>) => {
    const Icon = square ? SquareLogo : Logo;
    return <Icon ref={ref} {...iconProps} />;
  }
);
